var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldAlignHorizontally(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6.6c0-1.5.64-2.1 2.23-2.1h1.04c1.59 0 2.23.6 2.23 2.1v10.8c0 1.5-.64 2.1-2.23 2.1H6.98c-1.59 0-2.23-.6-2.23-2.1V6.6z",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 12H6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2v1.5h-2z",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 11.25v1.5h-3v-1.5h3z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 12H18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.75v-1.5h2.5c.41 0 .75.34.75.75s-.34.75-.75.75h-2.5zM13.25 8.6c0-1.5.64-2.1 2.23-2.1h1.04c1.59 0 2.23.6 2.23 2.1v6.8c0 1.5-.64 2.1-2.23 2.1h-1.04c-1.59 0-2.23-.6-2.23-2.1V8.6z",
    fill: "#292D32",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldAlignHorizontally);
export default __webpack_public_path__ + "static/media/vuesax-bold-align-horizontally.03dd1f93aabac2f0584c29772ecb457f.svg";
export { ForwardRef as ReactComponent };